import React, { useState, useEffect, useRef } from 'react';
import { Dimensions, SafeAreaView, ActivityIndicator, StyleSheet, View, Text, ScrollView, TextInput, TouchableOpacity, Alert, Image, Modal, FlatList } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Calendar } from 'react-native-calendars';
import { Linking } from 'react-native';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import { LinearGradient } from 'expo-linear-gradient';
import { Animated } from 'react-native';   // already have Animated in the project



const CreateSubmissionPage = ({ route, navigation }) => {

const [countdown, setCountdown] = useState(4);   // 4…3…2…1…0
const canSkip = countdown === 0;          
const timerRef = React.useRef(null);              // holds the interval id

const lastTrackedListingRef = React.useRef(null); // prevents double counting


const IMAGE_BASE = 'https://collabbayadmin.com/listings/';
const FALLBACK_BANNER = 'https://images.pexels.com/photos/1058277/pexels-photo-1058277.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1';

const parseBannerImages = (csv) => {
  if (!csv || !csv.trim()) return [FALLBACK_BANNER];
  const arr = csv
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(u => (u.startsWith('http') ? u : IMAGE_BASE + u));
  return arr.length ? arr : [FALLBACK_BANNER];
};


// --- AdvanceDays helpers ---
const pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);
const formatYMD = (d) => `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`;

const buildLocalDateTime = (dateStr, timeLabel) => {
  if (!dateStr || !timeLabel) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  const [hm, ampm] = timeLabel.split(' ');
  const [hStr, minStr] = hm.split(':');
  let h = parseInt(hStr, 10);
  const minutes = parseInt(minStr, 10);
  if (ampm?.toUpperCase() === 'PM' && h !== 12) h += 12;
  if (ampm?.toUpperCase() === 'AM' && h === 12) h = 0;
  const dt = new Date();
  dt.setFullYear(y, m - 1, d);
  dt.setHours(h, minutes, 0, 0);
  return dt;
};

const computeEarliestAllowedMidnight = (advanceDays) => {
  const base = new Date();
  base.setHours(0, 0, 0, 0);
  base.setDate(base.getDate() + advanceDays);
  return base;
};



const [screenTimePassed, setScreenTimePassed] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => {
    setScreenTimePassed(true);
  }, 5000); // 7 seconds

  return () => clearTimeout(timer); // Clean up
}, []);

  if (
    route.params.ListingID === 'LIST2219ECYF' &&
    typeof window !== 'undefined' &&
    document.referrer === ''
  ) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', padding: 20 }}>
        <Text style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 20 }}>Content restricted</Text>
        <TouchableOpacity
          onPress={() => window.location.href = 'https://collabbay.com'}
          style={{
            backgroundColor: '#FDF05D',
            paddingVertical: 12,
            paddingHorizontal: 20,
            borderRadius: 8,
            borderWidth: 2,
            borderColor: '#000',
          }}
        >
          <Text style={{ fontSize: 16, fontWeight: 'bold' }}>Head back to Collabbay</Text>
        </TouchableOpacity>
      </View>
    );
  }
  

  const [loadedThumbs, setLoadedThumbs] = useState({});


  const [listingData, setListingData] = useState(null);
  const [logoImage, setLogoImage] = useState('');
  const [userData, setUserData] = useState(null);
  const [collabData, setCollabData] = useState({
    ListingID: '',
    BrandName: '',
    BrandURL: '',
    BrandUserID: '',
    Redeem_Message: '',
    AdHeader: '',
    ListingDescription: '',
    Credits: '',
    CreditAvailableStart: '',
    Message: '',
    PreferredAvailability: '',
    ContentBrief: '',
  });
  
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('1:00 AM');
  const [message, setMessage] = useState('');
  const [bookedSlots, setBookedSlots] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [addedVisitors, setAddedVisitors] = useState(null);


  const [showWarning, setShowWarning] = useState(false);
  const [minFollowersRequired, setMinFollowersRequired] = useState(null);

  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('');
  const [engagementEmailData, setEngagementEmailData] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const [creatorFirstName, setCreatorFirstName] = useState('');
  const [creatorLastName, setCreatorLastName] = useState('');
  const [creatorPhoneNumber, setCreatorPhoneNumber] = useState('');
  const [additionalDetailsRequired, setAdditionalDetailsRequired] = useState(false);
  
  
// Bartering logic

  const [barterAllowed, setBarterAllowed] = useState(false);
  const [customOfferActive, setCustomOfferActive] = useState(false);
  const [customCredits, setCustomCredits] = useState('');
  const [customNonCreditOffer, setCustomNonCreditOffer] = useState('');
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  
  const [showInfoModal, setShowInfoModal] = useState(false);


  const [bannerLoaded, setBannerLoaded] = useState(false);
const [logoLoaded, setLogoLoaded] = useState(false);


// ➊ quick-feedback modal
const [exitSurveyVisible, setExitSurveyVisible] = useState(false);
const [selectedExitReason, setSelectedExitReason] = useState('');
const exitReasons = [
  { id: 'value_low',   label: 'Too low value' },
  { id: 'too_far',     label: 'Too far' },
  { id: 'venue_closed',label: 'Closed when I’m free' },
  { id: 'not_fan',     label: 'Brand’s not my style' },
  { id: 'other',     label: 'Other' },
];






// --- put this near the other consts ---
const SCREEN_WIDTH = Dimensions.get('window').width;
const MAX_BANNER_WIDTH = 600;
const BANNER_WIDTH = Math.min(SCREEN_WIDTH, MAX_BANNER_WIDTH) * 0.92;
const BANNER_HEIGHT = 246;


const [bannerImages, setBannerImages] = useState([]);
const [bannerIndex, setBannerIndex] = useState(0);
const bannerListRef = useRef(null);


const [venueShots, setVenueShots] = useState([]);
const [shotsModalVisible, setShotsModalVisible] = useState(false);
const [initialSlide, setInitialSlide] = useState(0);


const scaleAnim = useRef(new Animated.Value(0)).current;

useEffect(() => {
  const id = route?.params?.ListingID;
  if (!id) return;

  // ✅ prevent duplicate increments (re-renders / dev strict-mode)
  if (lastTrackedListingRef.current === id) return;
  lastTrackedListingRef.current = id;

  const url = 'https://collabbay.com/APIControllers/TrackListingViews.php';

  const opts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ ListingID: id }),
  };

  // ✅ helps on web if user navigates away quickly
  if (typeof window !== 'undefined') {
    opts.keepalive = true;
  }

  // fire-and-forget (non-blocking)
  fetch(url, opts).catch(() => {});
}, [route?.params?.ListingID]);


useEffect(() => {
  if (!route.params.ListingID) return;

  fetch(`https://collabbay.com/APIControllers/FetchVenueShots.php?ListingID=${route.params.ListingID}`)
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) {
        const validShots = data.filter(item =>
          item.Image &&
          typeof item.Image === 'string' &&
          item.Image.startsWith('http') &&
          item.Image.match(/\.(png|jpe?g|mp4|mov)$/i)
        );
        setVenueShots(validShots); // ✅ Full list for modal FlatList
      } else {
        setVenueShots([]);
      }
    })
    .catch(() => {
      setVenueShots([]);
    });
}, [route.params.ListingID]);


useEffect(() => {
  if (successModalVisible) {
    scaleAnim.setValue(0);
    Animated.spring(scaleAnim, {
      toValue: 1,
      friction: 5,
      tension: 80,
      useNativeDriver: true,
    }).start();
  }
}, [successModalVisible]);


  const areAllFieldsFilled = () => {
    const isCollabDataFilled = Object.keys(collabData)
      .filter(key => key !== 'Message') // Exclude optional "Message" field
      .every(key => collabData[key] !== '' && collabData[key] !== null);
  
    if (!isCollabDataFilled || !selectedDate || !selectedTime) {
      return false;
    }
  
    if (additionalDetailsRequired) {
      if (!creatorFirstName || !creatorLastName || !creatorPhoneNumber) return false;
    }
  
    return true;
  };
  



  const parsePreferredAvailability = (preferredAvailability) => {
    if (!preferredAvailability) return [];
    return preferredAvailability.split(',').map((block) => block.trim());
  };

  // --- Client-side availability helper ---
  // Only disables a time when PreferredAvailability can be read reliably.
  // If the format cannot be understood, it fails open and PHP remains authoritative.
  const normaliseWeekday = (dayText) => {
    const key = String(dayText || '').toLowerCase().replace(/[^a-z]/g, '');
    if (key.startsWith('mon')) return 'monday';
    if (key.startsWith('tue')) return 'tuesday';
    if (key.startsWith('wed')) return 'wednesday';
    if (key.startsWith('thu')) return 'thursday';
    if (key.startsWith('fri')) return 'friday';
    if (key.startsWith('sat')) return 'saturday';
    if (key.startsWith('sun')) return 'sunday';
    return '';
  };

  const getWeekdayFromDateString = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-').map(Number);
    if (parts.length !== 3 || parts.some(Number.isNaN)) return '';

    const localDate = new Date(parts[0], parts[1] - 1, parts[2]);
    const names = [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday'
    ];

    return names[localDate.getDay()] || '';
  };

  const parseAvailabilityTimeToMinutes = (rawTime) => {
    if (!rawTime) return null;

    const cleaned = String(rawTime)
      .trim()
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/\s+/g, ' ');

    if (cleaned === 'noon') return 12 * 60;
    if (cleaned === 'midnight') return 0;

    const match = cleaned.match(
      /^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?$/i
    );

    if (!match) return null;

    let hour = Number(match[1]);
    const minute = match[2] ? Number(match[2]) : 0;
    const meridiem = match[3]?.toLowerCase();

    if (minute < 0 || minute > 59) return null;

    if (meridiem) {
      if (hour < 1 || hour > 12) return null;

      if (meridiem === 'pm' && hour !== 12) {
        hour += 12;
      }

      if (meridiem === 'am' && hour === 12) {
        hour = 0;
      }
    } else if (hour < 0 || hour > 23) {
      return null;
    }

    return (hour * 60) + minute;
  };

  const getAvailabilityForSelectedDate = () => {
    if (!selectedDate || !collabData.PreferredAvailability) {
      return {
        parsed: false,
        ranges: []
      };
    }

    const selectedWeekday = getWeekdayFromDateString(selectedDate);

    if (!selectedWeekday) {
      return {
        parsed: false,
        ranges: []
      };
    }

    const availabilityText = String(collabData.PreferredAvailability)
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();

    const dayRegex =
      /\b(mon(?:day)?|tue(?:sday)?|tues|wed(?:nesday)?|thu(?:rsday)?|thur|thurs|fri(?:day)?|sat(?:urday)?|sun(?:day)?)\b/ig;

    const dayMatches = [];
    let dayMatch;

    while ((dayMatch = dayRegex.exec(availabilityText)) !== null) {
      dayMatches.push({
        index: dayMatch.index,
        end: dayRegex.lastIndex,
        day: normaliseWeekday(dayMatch[0]),
      });
    }

    // No clear weekday data = do not invent restrictions.
    if (dayMatches.length === 0) {
      return {
        parsed: false,
        ranges: []
      };
    }

    const selectedDayIndex = dayMatches.findIndex(
      (item) => item.day === selectedWeekday
    );

    // Venue explicitly lists weekdays but does not list this weekday.
    // Treat that day as unavailable.
    if (selectedDayIndex === -1) {
      return {
        parsed: true,
        ranges: []
      };
    }

    const selectedDayMatch = dayMatches[selectedDayIndex];
    const nextDayMatch = dayMatches[selectedDayIndex + 1];

    const segment = availabilityText
      .slice(
        selectedDayMatch.end,
        nextDayMatch ? nextDayMatch.index : availabilityText.length
      )
      .replace(/^\s*[:\-·|]\s*/, '')
      .trim();

    if (
      /\b(closed|unavailable|not available|n\/?a)\b/i.test(segment)
    ) {
      return {
        parsed: true,
        ranges: []
      };
    }

    if (
      /\b(open\s*)?24\s*(hours?|hrs?)\b/i.test(segment)
    ) {
      return {
        parsed: true,
        ranges: [
          {
            start: 0,
            end: 24 * 60
          }
        ]
      };
    }

    const rangeRegex =
      /(noon|midnight|\d{1,2}(?::\d{2})?\s*(?:am|pm)?)\s*(?:-|to|until)\s*(noon|midnight|\d{1,2}(?::\d{2})?\s*(?:am|pm)?)/ig;

    const ranges = [];
    let rangeMatch;

    while ((rangeMatch = rangeRegex.exec(segment)) !== null) {
      const start = parseAvailabilityTimeToMinutes(rangeMatch[1]);
      const end = parseAvailabilityTimeToMinutes(rangeMatch[2]);

      if (start !== null && end !== null) {
        ranges.push({
          start,
          end
        });
      }
    }

    // We found the weekday but cannot confidently parse its time format.
    // Fail open instead of making up a booking restriction.
    if (ranges.length === 0) {
      return {
        parsed: false,
        ranges: []
      };
    }

    return {
      parsed: true,
      ranges
    };
  };

  const isTimeWithinSelectedAvailability = (timeLabel) => {
    const availability = getAvailabilityForSelectedDate();

    // Fail open if PreferredAvailability cannot be reliably interpreted.
    if (!availability.parsed) {
      return true;
    }

    const timeMinutes = parseAvailabilityTimeToMinutes(timeLabel);

    if (timeMinutes === null) {
      return true;
    }

    if (availability.ranges.length === 0) {
      return false;
    }

    return availability.ranges.some(({ start, end }) => {
      // Normal range e.g. 12:00-21:00
      if (end >= start) {
        return timeMinutes >= start && timeMinutes <= end;
      }

      // Overnight range e.g. 18:00-02:00
      return timeMinutes >= start || timeMinutes <= end;
    });
  };


  const isDateAvailableForBooking = (dateString) => {
  if (!dateString || !collabData.PreferredAvailability) return true;

  const selectedWeekday = getWeekdayFromDateString(dateString);
  if (!selectedWeekday) return true;

  const availabilityText = String(collabData.PreferredAvailability)
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, ' ')
    .trim();

  const dayRegex =
    /\b(mon(?:day)?|tue(?:sday)?|tues|wed(?:nesday)?|thu(?:rsday)?|thur|thurs|fri(?:day)?|sat(?:urday)?|sun(?:day)?)\b/ig;

  const dayMatches = [];
  let dayMatch;

  while ((dayMatch = dayRegex.exec(availabilityText)) !== null) {
    dayMatches.push({
      index: dayMatch.index,
      end: dayRegex.lastIndex,
      day: normaliseWeekday(dayMatch[0]),
    });
  }

  if (dayMatches.length === 0) return true;

  const selectedDayIndex = dayMatches.findIndex(
    item => item.day === selectedWeekday
  );

  if (selectedDayIndex === -1) return false;

  const selectedDayMatch = dayMatches[selectedDayIndex];
  const nextDayMatch = dayMatches[selectedDayIndex + 1];

  const segment = availabilityText
    .slice(
      selectedDayMatch.end,
      nextDayMatch ? nextDayMatch.index : availabilityText.length
    )
    .replace(/^\s*[:\-·|]\s*/, '')
    .trim();

  if (/\b(closed|unavailable|not available|n\/?a)\b/i.test(segment)) {
    return false;
  }

  const rangeRegex =
    /(noon|midnight|\d{1,2}(?::\d{2})?\s*(?:am|pm)?)\s*(?:-|to|until)\s*(noon|midnight|\d{1,2}(?::\d{2})?\s*(?:am|pm)?)/i;

  if (rangeRegex.test(segment)) return true;

  if (/\b(open\s*)?24\s*(hours?|hrs?)\b/i.test(segment)) return true;

  return true;
};


const unavailableCalendarDates = {};

for (let i = 0; i < 365; i++) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + i);

  const key =
    `${d.getFullYear()}-` +
    `${String(d.getMonth() + 1).padStart(2, '0')}-` +
    `${String(d.getDate()).padStart(2, '0')}`;

  if (!isDateAvailableForBooking(key)) {
    unavailableCalendarDates[key] = {
      disabled: true,
      disableTouchEvent: true,
      customStyles: {
        container: {
          backgroundColor: '#F4F4F4',
        },
        text: {
          color: '#B5B5B5',
        },
      },
    };
  }
}

  const renderPreferredAvailability = () => {
    const parsedAvailability = parsePreferredAvailability(collabData.PreferredAvailability);
  
    if (parsedAvailability.length === 0) {
      return <Text style={styles.noAvailabilityText}>No availability data provided</Text>;
    }
  
    return (
      <View style={styles.availabilityContainer}>
        <Text style={styles.availabilityHeader}>Booking Availability</Text>
        <View style={styles.availabilityList}>
          {parsedAvailability.map((entry, index) => (
            <View key={index} style={styles.availabilityItem}>
              <Text style={styles.availabilityText}>{entry}</Text>
            </View>
          ))}
        </View>
      </View>
    );
  };
  
  
  const handleBackPress = () => {
    if (screenTimePassed) {
      const shouldShowSurvey = Math.random() < 0.01; // 34% chance
      if (shouldShowSurvey) {
        setExitSurveyVisible(true);
      } else {
        navigation.goBack(); // Skip survey randomly
      }
    } else {
      navigation.goBack(); // Skip survey if under 10s
    }
  };
  
  
  const sendExitSurvey = async (reasonText) => {
    try {
      // optimistic UI – do not block on network
      fetch('https://collabbay.com/APIControllers/CreatorDeclineOfferSurvey.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: userData?.Username,          // make sure you already populate userData elsewhere
          brandName: listingData?.BrandName,
          reason: reasonText,
        }),
      });
    } catch (e) {
      // silently ignore – we still want to leave the page
      console.log('survey error', e);
    } finally {
      setExitSurveyVisible(false);
      navigation.goBack();                      // original back behaviour
    }
  };
  

  useEffect(() => {
    if (exitSurveyVisible) {
      setCountdown(4);
      timerRef.current = setInterval(() => {
        setCountdown(prev => {
          // when we reach 0, just stop the timer – DO NOT close the modal
          if (prev === 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      clearInterval(timerRef.current);
    }
  
    // tidy-up if component unmounts
    return () => clearInterval(timerRef.current);
  }, [exitSurveyVisible]);
  
  

  useEffect(() => {
    const checkPromoterVerificationStatus = async () => {
      try {
        const response = await fetch('https://collabbay.com/APIControllers/CheckPromoterVerificationStatus.php', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include' // Ensure cookies are sent to maintain session
        });
        const data = await response.json();
  
        // Only check the status if it exists
        if (data.Status) {
          // Check if data.Status is not 'Public Figure'
          if (data.Status !== 'Public Figure') {
            setShowWarning(true);
          }
        } else {
          console.log('No status found, skipping verification check.');
        }
      } catch (error) {
        console.error('Error fetching promoter verification status:', error);
      }
    };
  
    checkPromoterVerificationStatus();
  }, []);
  

 
  useEffect(() => {
    const fetchListingData = async () => {
      setIsLoading(true); // Start loading before the API call
      try {
        const response = await fetch(`https://collabbay.com/APIControllers/RetrieveOfferDescription.php?ListingID=${route.params.ListingID}`);
        if (!response.ok) {
          throw new Error('Failed to fetch listing data');
        }
        const data = await response.json();
        setListingData(data); // Store the full response in the state
  
// Keep numeric AdvanceDays handy (NULL/'' means no restriction)
const advDays = (data?.AdvanceDays === null || data?.AdvanceDays === '' || isNaN(Number(data?.AdvanceDays)))
  ? null
  : Number(data.AdvanceDays);

        setBannerImages(parseBannerImages(data.LogoImage));
setBannerIndex(0);
setBannerLoaded(false);


        // Populate the form fields with the fetched data
        setAdditionalDetailsRequired(data?.AdditionalBookingDetails === 'Y');
        setMinFollowersRequired(data?.MinFollowersRequired);
        setBarterAllowed(data?.Barter === 'Y');
        setCollabData(prevCollabData => ({
          ...prevCollabData,
          ListingID: route.params.ListingID,
          BrandName: data.BrandName || '',
          BrandURL: data.BrandURL || '',
          BrandUserID: data.BrandUserID || '',
          Redeem_Message: data.Redeem_Message || '',
          AdHeader: data.AdHeader || '',
          ListingDescription: data.ListingDescription || '',
          Credits: data.Credits || '',
          PreferredAvailability: data.PreferredAvailability || '',
          ContentBrief: data.ContentBrief || '',
          LogoImage: data.LogoImage || '',
          Location: data.Location || '',
          MinFollowersRequired: data.MinFollowersRequired || '', // Set MinFollowersRequired field
          NonCreditOffer: data.NonCreditOffer || '', // Set NonCreditOffer field
          TurnAroundDays: data.TurnAroundDays || '',
        }));
      } catch (error) {
        console.error('Error fetching listing data:', error);
      } finally {
        setIsLoading(false); // End loading after the API call
      }
    };
  
    fetchListingData();
  }, [route.params.ListingID]);
  
  
  

  // Fix: fetchBookedSlots function to properly handle the PHP API response and parse date
  useEffect(() => {
    const fetchBookedSlots = async () => {
      try {
        const response = await fetch(`https://collabbay.com/APIControllers/RetrieveBookedTimes.php?ListingID=${route.params.ListingID}`);
        if (!response.ok) {
          throw new Error('Failed to fetch booked slots');
        }
        const data = await response.text(); // Get the plain text response
        const slots = data
          .split('<br>') // Split the data by line breaks
          .map(slot => slot.replace('CreditAvailableStart: ', '').trim()) // Remove the label
          .filter(Boolean); // Remove any empty entries
        setBookedSlots(slots); // Updated to handle the response correctly
      } catch (error) {
        console.error('Error fetching booked slots:', error);
      }
    };

    fetchBookedSlots();
  }, [route.params.ListingID]);


  useEffect(() => {
  if (bannerImages.length <= 1) return;
  const id = setInterval(() => {
    setBannerIndex((prev) => {
      const next = (prev + 1) % bannerImages.length;
      bannerListRef.current?.scrollToOffset({ offset: next * BANNER_WIDTH, animated: true });
      return next;
    });
  }, 2000); // 2 seconds
  return () => clearInterval(id);
}, [bannerImages.length]);





const onBannerScrollEnd = (e) => {
  const x = e?.nativeEvent?.contentOffset?.x || 0;
  const idx = Math.round(x / BANNER_WIDTH);
  if (!Number.isNaN(idx)) setBannerIndex(idx);
};


const scrollTo = (i) => {
  if (!bannerListRef.current || bannerImages.length === 0) return;
  const idx = ((i % bannerImages.length) + bannerImages.length) % bannerImages.length; // wrap
  bannerListRef.current.scrollToOffset({ offset: idx * BANNER_WIDTH, animated: true });
  setBannerIndex(idx);
};
const nextBanner = () => scrollTo(bannerIndex + 1);
const prevBanner = () => scrollTo(bannerIndex - 1);

const handleContinueBrowsing = () => {
  setSuccessModalVisible(false);

  navigation.navigate("SimilarVenues", {
    ListingID: collabData.ListingID
  });
};

const handleCloseToCollabbayHome = async () => {
  setSuccessModalVisible(false);

  try {
    if (typeof window !== 'undefined' && window.location) {
      window.location.href = 'https://collabbay.com';
      return;
    }

    await Linking.openURL('https://collabbay.com');
  } catch (error) {
    console.error('Unable to open Collabbay home:', error);
  }
};

const formatOfferForEmail = (nonCreditOffer, credits) => {
  const offerText = typeof nonCreditOffer === 'string' ? nonCreditOffer.trim() : '';
  const rawCredits = credits === null || credits === undefined ? '' : String(credits).trim();

  const valueText = rawCredits
    ? (rawCredits.startsWith('£') ? rawCredits : `£${rawCredits}`)
    : '';

  if (offerText && valueText) {
    return `${offerText} (offer value ${valueText})`;
  }

  if (offerText) {
    return offerText;
  }

  if (valueText) {
    return `the complimentary Collabbay offer (offer value ${valueText})`;
  }

  return 'the complimentary offer shown in the Collabbay listing';
};

const getEmailLaunchErrorMessage = () =>
  'Your booking was sent successfully, but we could not open your email app. You can continue browsing as normal.';

const handleEmailVenue = async () => {
  const data = engagementEmailData;

  if (!data?.eligible || !data?.available || !data?.venueEmail) {
    return;
  }

  const venueEmail = String(data.venueEmail).trim();

  const venueName = String(
    data.venueName || collabData.BrandName || 'venue'
  ).trim();

  const creatorUsername = String(
    data.creatorUsername || ''
  ).trim();

  const creatorDisplayName = String(
    data.creatorDisplayName || creatorUsername || 'the creator'
  ).trim();

  const bookingDateTime = String(
    data.bookingDateTime || `${selectedDate} ${selectedTime}`
  ).trim();

  const partySize =
    Number.isFinite(Number(data.partySize)) && Number(data.partySize) > 0
      ? Number(data.partySize)
      : (Number(addedVisitors || 0) + 1);

  const partyText = `${partySize} ${partySize === 1 ? 'person' : 'people'}`;

  const offer = formatOfferForEmail(
    data.nonCreditOffer,
    data.credits
  );

  const deliverables =
    String(data.contentBrief || '').trim() ||
    'the content outlined in the Collabbay listing';

  const creatorIntro =
    creatorUsername && creatorDisplayName !== creatorUsername
      ? `${creatorDisplayName} (Collabbay username: ${creatorUsername})`
      : creatorDisplayName;

  const signOff =
    creatorUsername && creatorDisplayName !== creatorUsername
      ? `${creatorDisplayName}\n${creatorUsername}`
      : creatorDisplayName;

  const variants = [
    `Hi ${venueName} team,

My name is ${creatorIntro}.

I've just sent a booking request through Collabbay to visit on ${bookingDateTime} for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

You can view my profile and previous content on Collabbay. If you're happy to go ahead, you can approve the request there. If the date doesn't work, feel free to suggest another one using the Move option.

Thanks and hope to hear from you.

Best,
${signOff}`,

    `Hi ${venueName} team,

My name is ${creatorIntro}.

Just a quick heads-up that I've submitted a booking request on Collabbay for ${bookingDateTime}, for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

You can take a look at my profile and previous content on Collabbay. If you're happy with the request, you can approve it on the platform. If the proposed date isn't convenient, you're also welcome to suggest another one using the Move option.

Thanks very much and hope to hear from you.

Best,
${signOff}`,

    `Hi ${venueName} team,

My name is ${creatorIntro}.

I've just requested a visit through Collabbay for ${bookingDateTime}, for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

My profile and previous content are available to view on Collabbay. If everything looks good, you can approve the request there. If the date doesn't work for you, feel free to suggest another date using the Move option.

Thanks, and I hope to hear from you.

Best,
${signOff}`,

    `Hi ${venueName} team,

My name is ${creatorIntro}.

I wanted to let you know I've just sent over a Collabbay booking request for ${bookingDateTime}, for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

You can review my profile and previous content on Collabbay. If you're happy to proceed, you can approve the request on the platform. If that date isn't suitable, please feel free to suggest another one using the Move option.

Thanks and hope to hear from you soon.

Best,
${signOff}`
  ];

  const variantIndex = Number.isInteger(data.emailVariantIndex)
    ? data.emailVariantIndex % variants.length
    : Math.floor(Math.random() * variants.length);

  const body = variants[variantIndex];

  const subject =
    `Collab Bay booking request – ${creatorUsername || creatorDisplayName}`;

  const mailtoURL =
    `mailto:${encodeURIComponent(venueEmail)}` +
    `?bcc=${encodeURIComponent('collabbaycloud@gmail.com')}` +
    `&subject=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(body)}`;

  try {
    await Linking.openURL(mailtoURL);
  } catch (error) {
    console.error('Unable to open mail client:', error);

    const errorMessage = getEmailLaunchErrorMessage();

    if (
      typeof window !== 'undefined' &&
      typeof window.alert === 'function'
    ) {
      window.alert(errorMessage);
    } else {
      Alert.alert('Email app unavailable', errorMessage);
    }
  }
};


const handleCollabPress = async () => {
    if (isSubmitting) return; // Prevent double click
    setIsSubmitting(true);    // Lock the button
  
    if (addedVisitors === null) {
      alert('Please select how many additional visitors will attend...');
      setIsSubmitting(false); // Re-enable button
      return;
    }
  

// --- AdvanceDays client check (server also enforces) ---
try {
  const rawAdv = listingData?.AdvanceDays;
  if (rawAdv !== null && rawAdv !== '' && !isNaN(Number(rawAdv))) {
    const adv = Number(rawAdv);
    if (adv > 0) {
      const proposed = buildLocalDateTime(selectedDate, selectedTime);
      if (!proposed) {
        alert('Please select a date and time.');
        setIsSubmitting(false);
        return;
      }
      const earliest = computeEarliestAllowedMidnight(adv);
      if (proposed < earliest) {
        setErrorMessage(`This venue requires at least ${adv} day(s) notice. Earliest you can book is ${formatYMD(earliest)}.`);
        setErrorModalVisible(true);
        setIsSubmitting(false);
        return;
      }
    }
  }
} catch(e) { /* fail open; PHP re-checks */ }


    try {
      const fullDateTime = `${selectedDate} ${selectedTime}`;
      
      const updatedCollabData = {
        ...collabData,
        CreditAvailableStart: fullDateTime,
        Message: message.trim(),
        Credits: customCredits.trim() !== '' ? customCredits.trim() : collabData.Credits,
        NonCreditOffer: customNonCreditOffer.trim() !== '' ? customNonCreditOffer.trim() : collabData.NonCreditOffer,
      };
      
 const postData = {
  ...updatedCollabData,
  AddedVisitors: addedVisitors,
  PointsEarned: listingData?.PointsEarned ?? 0,   // ✅ send to PHP
  ...(additionalDetailsRequired && {
    CreatorFirstName: creatorFirstName.trim(),
    CreatorLastName: creatorLastName.trim(),
    CreatorPhoneNumber: creatorPhoneNumber.trim(),
  }),
};

  
      const response = await fetch('https://collabbay.com/APIControllers/InsertCollabSubmission.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData),
      });
  
      const result = await response.json();


if (response.ok && result.success) {
  setRedirectUrl(result.redirectUrl);

  const engagement = result?.engagementEmail;

  const venueEmail =
    typeof engagement?.venueEmail === 'string'
      ? engagement.venueEmail.trim()
      : '';

  const hasUsableVenueEmail =
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(venueEmail);

  if (
    engagement?.eligible === true &&
    engagement?.available === true &&
    hasUsableVenueEmail
  ) {
    setEngagementEmailData({
      ...engagement,
      venueEmail,
      emailVariantIndex: Math.floor(Math.random() * 4),
    });
  } else {
    setEngagementEmailData(null);
  }

  setSuccessModalVisible(true);

} else if (result.error === "Selected date and time do not match the brand's preferred availability.") {
        setErrorMessage('Booking Error. Check that your selected date and time is within the venue\'s opening time.');
        setErrorModalVisible(true);
      } else if (result.message) {
        setErrorMessage('This offer has a minimum follower requirement.');
        setErrorModalVisible(true);
      } else {
        setErrorMessage(result.error || 'An error occurred during submission.');
        setErrorModalVisible(true);
      }
  
    } catch (error) {
      console.error('Submission Error:', error);
      setErrorMessage('An error occurred while submitting the form.');
      setErrorModalVisible(true);
    } finally {
      setIsSubmitting(false); // Unlock the button once complete
    }
  };
  
  
  

  useEffect(() => {
    const fetchLogoImage = async () => {
      try {
        // Use listingData?.BrandName dynamically in the fetch URL
        const response = await fetch(`https://collabbay.com/APIControllers/GetBrandLogoImage.php?BrandName=${listingData?.BrandName}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch logo image');
        }
  
        const data = await response.json();
  
        if (data.success) {
          // Set the ProfileImage from the response
          setLogoImage(data.ProfileImage);
        } else {
          console.error('Logo image fetch unsuccessful');
        }
      } catch (error) {
        console.error('Error fetching logo image:', error);
      }
    };
  
    // Ensure listingData?.BrandName exists before calling the fetch function
    if (listingData?.BrandName) {
      fetchLogoImage();
    }
  
  }, [listingData?.BrandName]);

  // Render Booked Slots: Update this to echo the correct format
  const renderBookedSlots = () => {
    const displayedSlots = expanded ? bookedSlots : bookedSlots.slice(0, 3);

    return (
      <View>
        {bookedSlots.length > 0 && (
          <View style={styles.bookedRecentlyPill}>
            <Ionicons name="eye-outline" size={16} color="#111111" />
            <Text style={styles.bookedRecentlyText}>
              <Text style={styles.bookedRecentlyCount}>{bookedSlots.length}</Text> booked recently
            </Text>
          </View>
        )}
      </View>
    );
  };

  const renderContentBrief = () => {
    if (collabData.ContentBrief) {
      const contentBriefItems = collabData.ContentBrief.split(',').map(item => item.trim());
      return (
        <View style={styles.contentBriefContainer}>
          <Text style={styles.eyebrowLabel}>DELIVERABLES</Text>
          <Text style={styles.sectionTitle}>Content Brief</Text>
          <View style={styles.briefList}>
            {contentBriefItems.map((item, index) => (
              <View key={index} style={styles.briefRow}>
                <View style={styles.briefCheck}>
                  <Ionicons name="checkmark" size={13} color="#111111" />
                </View>
                <Text style={styles.bulletPoint}>{item}</Text>
              </View>
            ))}
          </View>
        </View>
      );
    }
    return null;
  };

// —— BLOCKED ADVANCE DAYS (default at least 1 day) ——
const effectiveAdv = Math.max(1, Number(listingData?.AdvanceDays || 0)); // default to 1 if null/0
const blocked = {};
for (let i = 0; i < effectiveAdv; i++) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + i);
  const key =
    `${d.getFullYear()}-` +
    `${String(d.getMonth() + 1).padStart(2, '0')}-` +
    `${String(d.getDate()).padStart(2, '0')}`;

  blocked[key] = {
    disabled: true,
    disableTouchEvent: true,
    customStyles: {
      container: { backgroundColor: '#F4F4F4' },
      text: { color: '#B5B5B5' },
    },
  };
}


  
  return (
<SafeAreaView style={styles.container}>
{isLoading ? (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="black" />
      </View>
    ) : listingData?.PauseLiveToggle === 'Pause' ? (
      <View style={styles.loadingContainer}>
        <Text style={{ textAlign: 'center', fontSize: 18 }}>
          This listing is currently paused.
        </Text>
      </View>
    ) : (
      <ScrollView
        style={{
          maxWidth: 600,
          width: '100%',
          alignSelf: 'center',
          flex: 1,
        }}
        contentContainerStyle={styles.contentContainer}
      >
  
  
        <View style={styles.bannerContainer}> 
          {/* Top Image: listingData.LogoImage */}
  
{/* Banner slider – single or multiple images */}
<FlatList
  ref={bannerListRef}
  data={bannerImages}
  horizontal
  pagingEnabled
  showsHorizontalScrollIndicator={false}
  keyExtractor={(u, i) => u + i}
  getItemLayout={(_, i) => ({
    length: BANNER_WIDTH,
    offset: BANNER_WIDTH * i,
    index: i,
  })}
  style={{ width: BANNER_WIDTH, height: BANNER_HEIGHT, alignSelf: 'center' }}
  renderItem={({ item }) => (
    <ShimmerPlaceHolder
      LinearGradient={LinearGradient}
      visible={bannerLoaded}
      shimmerColors={['#e0e0e0', '#f3f3f3', '#e0e0e0']}
      style={{ width: BANNER_WIDTH, height: BANNER_HEIGHT, borderRadius: 24 }}
    >
      <Image
        source={{ uri: item }}
        style={{ width: BANNER_WIDTH, height: BANNER_HEIGHT, borderRadius: 24 }}
        resizeMode="cover"
        onLoad={() => setBannerLoaded(true)}
        onError={() => setBannerLoaded(true)}
      />
    </ShimmerPlaceHolder>
  )}
/>

{/* Arrows + dots only show if >1 image */}
{bannerImages.length > 1 && (
  <>
    <TouchableOpacity style={styles.bannerArrowRight} onPress={nextBanner}>
      <Ionicons name="chevron-forward" size={20} color="#000" />
    </TouchableOpacity>

    <View style={styles.dotsWrap}>
      {bannerImages.map((_, i) => (
        <TouchableOpacity key={i} onPress={() => scrollTo(i)}>
          <View style={[styles.dot, i === bannerIndex && styles.dotActive]} />
        </TouchableOpacity>
      ))}
    </View>
  </>
)}



          <View style={styles.backContainer}>
            <TouchableOpacity style={styles.backButton} onPress={handleBackPress}>
              <Ionicons name="arrow-back" size={22} color="black" />
            </TouchableOpacity>
          </View>

          {/* Bottom Image: logoImage */}
          <View style={styles.logoContainer}>
  {logoImage ? (
    <View style={styles.logoShell}>
      <View style={styles.logoClip}>
        <Image
          source={{ uri: logoImage }}  // Use the logoImage state directly
          style={styles.logo}
          resizeMode="cover"
        />
      </View>
    </View>
  ) : null}

{bookedSlots.length > 0 && renderBookedSlots()}
</View>
        </View>

        <View style={styles.section}>

<Text style={styles.headerSectionTitle}>
  {(listingData?.OnBehalfOf && listingData?.OnBehalfOf.trim() !== '')
    ? listingData.OnBehalfOf
    : listingData?.BrandName} Collab Offer
  <Text style={{ color: '#FDF05D', fontWeight: '900' }}>.</Text>
</Text>



<Modal
  animationType="fade"
  transparent={true}
  visible={successModalVisible}
  onRequestClose={() => setSuccessModalVisible(false)}
>
  <View style={styles.modalContainer}>
    <Animated.View
      style={[
        styles.successCard,
        styles.successCardRefined,
        engagementEmailData?.eligible &&
          engagementEmailData?.available &&
          styles.successCardEligible,
        { transform: [{ scale: scaleAnim }] }
      ]}
    >
      <TouchableOpacity
        style={styles.successCloseButton}
        onPress={handleCloseToCollabbayHome}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        activeOpacity={0.8}
      >
        <Ionicons name="close" size={20} color="#111111" />
      </TouchableOpacity>

      <ScrollView
        style={styles.successScrollView}
        contentContainerStyle={styles.successScrollContent}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.successIconWrap}>
          <Ionicons name="checkmark" size={28} color="#166534" />
        </View>

        {parseInt(listingData?.PointsEarned ?? 0) > 0 && (
          <View style={styles.rewardPill}>
            <Text style={styles.rewardPillText}>
              {parseInt(
                listingData?.PointsEarned ?? 0
              ).toLocaleString()} CƵ earned
            </Text>
          </View>
        )}

        <Text style={styles.successTitle}>
          Booking request sent
        </Text>

        <Text style={styles.successSubtitle}>
          If the venue approves, you’ll be notified. Otherwise, the request will expire.
        </Text>

        {engagementEmailData?.eligible &&
        engagementEmailData?.available ? (
          <>
            <View style={styles.successDivider} />

            <View style={styles.engagementModernCard}>
              <View style={styles.engagementHeaderRow}>
                <View style={styles.engagementMiniLabel}>
                  <Ionicons
                    name="stats-chart"
                    size={14}
                    color="#1D4ED8"
                    style={{ marginRight: 6 }}
                  />
                  <Text style={styles.engagementMiniLabelText}>
                    BOOST
                  </Text>
                </View>

                <View style={styles.engagementOptionalBadgeDark}>
                  <Text style={styles.engagementOptionalBadgeDarkText}>
                    OPTIONAL
                  </Text>
                </View>
              </View>

              <View style={styles.engagementHeadlineRow}>
                <View style={styles.engagementIconWrapBlue}>
                  <Ionicons
                    name="stats-chart"
                    size={22}
                    color="#1D4ED8"
                  />
                </View>

                <Text style={styles.engagementTitleGradient}>
                  Increase your chance of being accepted?
                </Text>
              </View>

              <Text style={styles.engagementBodyRefined}>
                We’ve already notified the venue. Sending a quick personal note can help your request stand out. We've prepped a note template for you. 
              </Text>

              <TouchableOpacity
                style={styles.emailVenueButtonRefined}
                onPress={handleEmailVenue}
                activeOpacity={0.85}
              >
                <Ionicons
                  name="paper-plane-outline"
                  size={18}
                  color="#111827"
                  style={{ marginRight: 10 }}
                />

                <Text style={styles.emailVenueButtonTextRefined}>
                  Email venue
                </Text>
              </TouchableOpacity>
            </View>
          </>
        ) : null}

        <TouchableOpacity
          style={styles.continueBrowsingPrimaryButton}
          onPress={handleContinueBrowsing}
          activeOpacity={0.88}
        >
          <Text style={styles.continueBrowsingPrimaryButtonText}>
            Continue browsing
          </Text>
        </TouchableOpacity>
      </ScrollView>
    </Animated.View>
  </View>
</Modal>






<Modal
  animationType="fade"
  transparent={true}
  visible={errorModalVisible}
  onRequestClose={() => setErrorModalVisible(false)}
>
  <View style={styles.modalContainer}>
    <View style={styles.modalContent}>
      <Ionicons name="alert-circle-outline" size={48} color="red" />
      <Text style={styles.modalText}>{errorMessage}</Text>
      <TouchableOpacity
        style={styles.modalButton}
        onPress={() => setErrorModalVisible(false)}
      >
        <Text style={styles.modalButtonText}>Close</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>


{venueShots.length > 0 && (
  <>
    <View style={{ flexDirection: 'row', marginTop: 16, marginBottom: 18 }}>
    {venueShots.slice(0, 5).map((shot, idx) => {
  const isVideo = shot.Image?.endsWith('.mp4');
  return (
    <TouchableOpacity
      key={idx}
      style={{ marginRight: idx === venueShots.length - 1 ? 0 : 10 }}
      onPress={() => {
        setInitialSlide(idx);
        setShotsModalVisible(true);
      }}
    >


{isVideo ? (
  <>
    {!loadedThumbs[idx] && (
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 10,
          backgroundColor: '#e5e5e5',
        }}
      />
    )}

    <video
      src={shot.Image}
      muted
      playsInline
      preload="auto"
      onLoadedData={() =>
        setLoadedThumbs(prev => ({ ...prev, [idx]: true }))
      }
      style={{
        display: loadedThumbs[idx] ? 'block' : 'none',
        width: 54,
        height: 54,
        borderRadius: 16,
        backgroundColor: '#000',
        objectFit: 'cover',
      }}
    />
  </>
) : (
  <>
    {!loadedThumbs[idx] && (
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 10,
          backgroundColor: '#e5e5e5',
        }}
      />
    )}

    <Image
      source={{ uri: shot.Image }}
      onLoad={() =>
        setLoadedThumbs(prev => ({ ...prev, [idx]: true }))
      }
      style={{
        display: loadedThumbs[idx] ? 'flex' : 'none',
        width: 54,
        height: 54,
        borderRadius: 16,
        backgroundColor: '#000',
      }}
      resizeMode="cover"
    />
  </>
)}


    </TouchableOpacity>
  );
})}

    </View>

    <Modal
      visible={shotsModalVisible}
      transparent
      onRequestClose={() => setShotsModalVisible(false)}
    >
      <View style={{ flex: 1, backgroundColor: 'black' }}>
       <FlatList
  data={venueShots}
  horizontal
  pagingEnabled
  initialScrollIndex={initialSlide}
  getItemLayout={(_, i) => ({
    length: SCREEN_WIDTH,
    offset: SCREEN_WIDTH * i,
    index: i,
  })}
  keyExtractor={(_, i) => String(i)}
 renderItem={({ item }) => {
  const uri = item.Image || item.FileURL;
  const isVideo = uri?.endsWith('.mp4');



  return isVideo ? (
  <video
    src={uri}
    controls
    autoPlay
    playsInline
    preload="metadata"
    style={{
      width: SCREEN_WIDTH,
      height: Dimensions.get('window').height,
      objectFit: 'contain',
    }}
  />
) : (
  <Image
    source={{ uri }}
    style={{ width: SCREEN_WIDTH, height: Dimensions.get('window').height }}
    resizeMode="contain"
  />
);

}}

/>


        <TouchableOpacity
          onPress={() => setShotsModalVisible(false)}
          style={{
            position: 'absolute',
            top: 40,
            right: 20,
            zIndex: 999,
          }}
        >
          <Ionicons name="close-circle" size={36} color="white" />
        </TouchableOpacity>
      </View>
    </Modal>
  </>
)}


<View style={styles.section}>
  {minFollowersRequired && (
    <View style={styles.followersRequirementBox}>
      <Text style={styles.followersRequirementText}>{minFollowersRequired} followers required</Text>
    </View>
  )}



</View>

          {showWarning && (
  <View style={styles.warningCard}>
    <Ionicons name="warning-outline" size={24} color="black" />
    <Text style={styles.warningText}>
      Hey! Your account is under review. You will not be able to propose bookings until your account is verified. Keep an eye on your inbox.
    </Text>
  </View>
)}


<View style={styles.urlContainer}>
  <Ionicons name="link" size={20} color="black" />
  <TouchableOpacity
    style={{ flexShrink: 1 }} // ensures Text doesn't overflow
    onPress={() => Linking.openURL(`https://${listingData?.BrandURL}`)}
  >
    <Text style={[styles.urlText, { flexShrink: 1, flexWrap: 'wrap' }]}>
      {listingData?.BrandURL}
    </Text>
  </TouchableOpacity>
</View>




          <View style={styles.descriptionBox}>
        
            <Text style={styles.description}>{listingData?.ListingDescription}</Text>
          </View>
          
       </View>

        <View style={styles.locationContainer}>
          <Ionicons name="location-sharp" size={20} color="black" />
          <Text style={styles.sectionTitleAddress}>{listingData?.Location}</Text>
        </View>



        <View style={styles.section}>

  {renderPreferredAvailability()}

</View>




        <View style={styles.locationContainer}>
          <Ionicons name="logo-instagram" size={20} color="black" />
          <Text style={styles.sectionTitleAddress}>Post Type : Reel</Text>
        </View>

        <View style={styles.locationContainer}>
  <Ionicons name="calendar" size={20} color="black" />
  <Text style={styles.sectionTitleAddress}>
    Turnaround Time: {listingData?.TurnAroundDays || 'N/A'} Days
  </Text>
</View>

        {/* Content Brief */}
        {renderContentBrief()}


        <View style={styles.offerUnifiedCard}>
  {/* Header */}
  <Text style={styles.eyebrowLabel}>YOUR OFFER</Text>
  <Text style={styles.offerMainTitle}>What you’ll receive</Text>

  {/* Offer Content */}
  <View style={styles.offerHighlightBox}>
    <Text style={styles.offerHighlightText}>
      {listingData?.NonCreditOffer || 'N/A'}
    </Text>
  </View>

  {/* Offer Value Row with Info Icon */}
  <TouchableOpacity style={styles.offerValueRow} onPress={() => setShowInfoModal(true)}>
    <Ionicons name="wallet-outline" size={22} color="#000" style={{ marginRight: 10 }} />
    <View>
      <Text style={styles.offerValueLabel}>Offer Value</Text>
      <Text style={styles.offerValueAmount}>£{listingData?.Credits || 'N/A'}</Text>
    </View>
    <Ionicons name="information-circle-outline" size={20} color="#000" style={{ marginLeft: 'auto' }} />
  </TouchableOpacity>
</View>

{/* Offer Value Info Modal */}
<Modal
  animationType="fade"
  transparent={true}
  visible={showInfoModal}
  onRequestClose={() => setShowInfoModal(false)}
>
  <View style={styles.modalContainer}>
    <View style={styles.modalContent}>
      <Ionicons name="information-circle-outline" size={48} color="black" />
      <Text style={styles.modalText}>
        <Text style={{ fontWeight: 'bold' }}>What is the offer value?</Text>{"\n\n"}
        This is the estimated value of the goods/services included in the offer.
        {"\n\n"}Example: 2 comped mains worth £25 each = a £50 offer value.
        {"\n\n"}Note: This is not a cash payout, tab, or exact credit voucher unless stated so in the offer. The offer value is provided by the venue as a valuation based on the price of the comped goods. 
        {"\n\n"}When redeeming this collab, your order cannot exceed the offer value. 
      </Text>
      <TouchableOpacity style={styles.modalButton} onPress={() => setShowInfoModal(false)}>
        <Text style={styles.modalButtonText}>Makes Sense 👍</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>


        {barterAllowed && (
  <View style={styles.customOfferWrap}>
    {!customOfferActive ? (
      <TouchableOpacity
        style={styles.customOfferPromptButton}
        onPress={() => setCustomOfferActive(true)}
        activeOpacity={0.8}
      >
        <Text style={styles.customOfferPromptText}>Request a different offer</Text>
        <Ionicons name="arrow-forward" size={16} color="#4A4A4A" />
      </TouchableOpacity>
    ) : (
      <View style={styles.customOfferPanel}>
        <Text style={styles.customOfferTitle}>Your proposed offer</Text>
        <Text style={styles.customOfferHelper}>Suggest an alternative for the venue to review.</Text>

        <View>
  <TextInput
    placeholder="What would you like the venue to offer you? i.e. 2 mains, sides and desserts"
    value={customNonCreditOffer}
    onChangeText={setCustomNonCreditOffer}
    maxLength={200}
    multiline
    style={styles.customOfferTextarea}
  />
  <Text style={styles.customOfferCounter}>
    {customNonCreditOffer.length} / 200
  </Text>
</View>

<TextInput
  placeholder="Value of offer you'd like, i.e. £50"
  keyboardType="numeric"
  value={customCredits}
  onChangeText={setCustomCredits}
  style={styles.customOfferInput}
/>

      </View>
    )}
  </View>
)}



        <View style={styles.bookingIntro}>
          <Text style={styles.eyebrowLabel}>BOOKING</Text>
          <Text style={styles.bookingTitle}>Choose your visit</Text>
          <Text style={styles.bookingHelper}>Select a date and then choose a time.</Text>
        </View>

        <View style={styles.calendarContainer}>
          <Text style={styles.stepLabel}>1 · Select a date</Text>
<Calendar
  onDayPress={(day) => {
    if (!isDateAvailableForBooking(day.dateString)) return;

    setSelectedDate(day.dateString);
    setSelectedTime('');
  }}
  markedDates={{
    ...unavailableCalendarDates,
    ...blocked,

    ...(selectedDate &&
      isDateAvailableForBooking(selectedDate) &&
      !blocked[selectedDate]
      ? {
          [selectedDate]: {
            selected: true,
            selectedColor: '#FDF05D',
            selectedTextColor: '#111111',
          },
        }
      : {}),
  }}
  minDate={formatYMD(new Date())}
  markingType="custom"
  renderArrow={(direction) => (
    <Ionicons
      name={direction === 'left' ? 'chevron-back' : 'chevron-forward'}
      size={24}
      color="black"
    />
  )}
  theme={{
    backgroundColor: '#FFFFFF',
    calendarBackground: '#FFFFFF',
    textSectionTitleColor: '#8A8A8A',
    dayTextColor: '#222222',
    monthTextColor: '#111111',
    textMonthFontWeight: '600',
    textDayFontWeight: '400',
    textDayHeaderFontWeight: '500',
    textDisabledColor: '#C8C8C8',
    todayTextColor: '#111111',
    selectedDayBackgroundColor: '#FDF05D',
    selectedDayTextColor: '#111111',
    arrowColor: '#111111',
  }}
/>

        </View>



<View style={styles.timePickerContainer}>
  <Text style={styles.stepLabel}>2 · Select a time</Text>

  <ScrollView
    style={styles.timeScrollView}
    contentContainerStyle={styles.timeGrid}
    showsVerticalScrollIndicator={false}
  >
    {Array.from({ length: 40 }, (_, i) => {
      const hour = Math.floor((i + 14) / 2) % 24;
      const minute = (i % 2) === 0 ? '00' : '30';
      const ampm = hour >= 12 && hour < 24 ? 'PM' : 'AM';
      const adjustedHour = hour % 12 === 0 ? 12 : hour % 12;
      const timeLabel = `${adjustedHour}:${minute} ${ampm}`;

      const isOutsideAvailability = selectedDate
        ? !isTimeWithinSelectedAvailability(timeLabel)
        : false;

      return (
        <TouchableOpacity
          key={i}
          disabled={isOutsideAvailability}
          activeOpacity={isOutsideAvailability ? 1 : 0.75}
          style={[
            styles.timeSlot,
            isOutsideAvailability && styles.disabledTimeSlot,
            selectedTime === timeLabel &&
              !isOutsideAvailability &&
              styles.selectedTimeSlot
          ]}
          onPress={() => {
            if (!isOutsideAvailability) {
              setSelectedTime(timeLabel);
            }
          }}
        >
          <Text
            style={[
              styles.timeSlotText,
              isOutsideAvailability && styles.disabledTimeSlotText,
              selectedTime === timeLabel &&
                !isOutsideAvailability &&
                styles.selectedTimeSlotText
            ]}
          >
            {timeLabel}
          </Text>
        </TouchableOpacity>
      );
    })}
  </ScrollView>
</View>



{additionalDetailsRequired && (
  <View style={styles.additionalDetailsCard}>
    <Text style={styles.cardTitle}>Booking details</Text>
    <Text style={styles.cardHelper}>These details are required for this venue.</Text>
    <TextInput
      style={styles.inputField}
      placeholder="First Name"
      value={creatorFirstName}
      onChangeText={setCreatorFirstName}
    />
    <TextInput
      style={styles.inputField}
      placeholder="Last Name"
      value={creatorLastName}
      onChangeText={setCreatorLastName}
    />
    <TextInput
      style={styles.inputField}
      placeholder="Phone Number"
      keyboardType="phone-pad"
      value={creatorPhoneNumber}
      onChangeText={(text) => {
        // Basic validation to only allow numbers
        if (/^\d*$/.test(text)) setCreatorPhoneNumber(text);
      }}
    />
  </View>
)}

        <View style={styles.messageInput}>
          <View style={styles.messageTitleRow}>
            <Text style={styles.messageInputTitle}>Add a message</Text>
            <Text style={styles.optionalLabel}>Optional</Text>
          </View>
          <TextInput
            style={styles.messageBoxInput}
            placeholder="Type your message here"
            multiline
            value={message}
            onChangeText={setMessage}
            maxLength={170}
          />
           <Text style={styles.charCounter}>
            {message.length} / 170
        </Text>
        </View>

        <View style={styles.visitorInputContainer}>
          <Text style={styles.visitorInputLabel}>Additional Visitors?</Text>
          <Text style={styles.plusOneLabel}>Plus ones are not directly included in Collabbay offers. Let the brand know who you plan to bring and they can advise at their discretion.</Text>
      
          <View style={styles.visitorOptions}>
            <TouchableOpacity onPress={() => setAddedVisitors(0)}>
              <Text style={[styles.visitorOption, addedVisitors === 0 && styles.selectedVisitorOption]}>0</Text>
            </TouchableOpacity>
            {Array.from({ length: 5 }, (_, i) => (
              <TouchableOpacity key={i + 1} onPress={() => setAddedVisitors(i + 1)}>
                <Text style={[styles.visitorOption, addedVisitors === i + 1 && styles.selectedVisitorOption]}>+{i + 1}</Text>
              </TouchableOpacity>
            ))}
          </View>
         
        </View>

    {!showWarning ? (
  <TouchableOpacity
    style={[styles.collabButton, isSubmitting && { opacity: 0.6 }]}
    onPress={handleCollabPress}
    disabled={isSubmitting}
  >
    <Text style={styles.collabButtonText}>
      {isSubmitting ? 'Submitting...' : 'Submit Collab Request'}
    </Text>

    {/* ➕ always show earnable CZ */}
    <Text style={styles.ctaRewardText}>
      Earn +{parseInt(listingData?.PointsEarned ?? 0).toLocaleString()} CƵ 🪙
    </Text>
  </TouchableOpacity>
) : (
  <View style={styles.verificationCard}>
    <Ionicons name="shield-checkmark-outline" size={28} color="black" />
    <Text style={styles.verificationText}>
      Your account is being run through our verification process. Hang tight...
    </Text>
    <Text
      style={[
        styles.verificationText,
        { fontWeight: 'normal', fontSize: 14, marginTop: 6 }
      ]}
    >
      You'll be notified if verified. In the meantime, update your profile. Welcome!
    </Text>
    <ActivityIndicator size="small" color="black" style={{ marginTop: 10 }} />
  </View>
)}

      </ScrollView>
       )}


{/* ---------- EXIT-SURVEY MODAL ---------- */}
<Modal
  animationType="fade"
  transparent
  visible={exitSurveyVisible}
  onRequestClose={() => {
    clearInterval(timerRef.current);
    setExitSurveyVisible(false);
    navigation.goBack();
  }}
>
  <View style={styles.modalContainer}>
    <View style={styles.exitSurveyCard}>
      <View style={styles.exitSurveyHandle} />
      <Text style={styles.exitSurveyTitle}>
        Quick one – why didn’t you book?
      </Text>
      <Text style={styles.exitSurveySubtitle}>
        Update your preferences.
      </Text>

      {/* answer buttons */}
      {exitReasons.map((r) => (
        <TouchableOpacity
          key={r.id}
          onPress={() => {
            setSelectedExitReason(r.id);
         
            sendExitSurvey(r.label);

          }}
          style={[
            styles.exitReasonButton,
            selectedExitReason === r.id && styles.exitReasonButtonSelected,
          ]}
        >
          <Text style={styles.exitReasonText}>{r.label}</Text>
        </TouchableOpacity>
      ))}

      {/* progress bar 0 → 4 s  (fills right-to-left) */}
      <View style={styles.exitProgressTrack}>
        <View
          style={[
            styles.exitProgressFill,
            { width: `${(4 - countdown) / 4 * 100}%` },
          ]}
        />
      </View>

{/* skip */}
<TouchableOpacity
  disabled={!canSkip}
  style={[styles.exitSkipButton, { opacity: canSkip ? 1 : 0.4 }]}
  onPress={() => {
    if (!canSkip) return;
    clearInterval(timerRef.current);
    setExitSurveyVisible(false);
    navigation.goBack();
  }}
>
  <Text style={styles.exitSkipText}>
    {canSkip ? 'Skip' : `Skip (${countdown})`}
  </Text>
</TouchableOpacity>

    </View>
  </View>
</Modal>
{/* ---------- /EXIT-SURVEY MODAL ---------- */}




    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  contentContainer: {
    paddingHorizontal: 18,
    paddingTop: 8,
    paddingBottom: 34,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 24,
  },

  // Hero
  bannerContainer: {
    position: 'relative',
    marginTop: 8,
    marginBottom: 34,
  },
  backContainer: {
    position: 'absolute',
    top: 14,
    left: 14,
    zIndex: 10,
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255,255,255,0.96)',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.06)',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.10,
    shadowRadius: 8,
    elevation: 3,
  },
  logoContainer: {
    position: 'absolute',
    left: 16,
    right: 16,
    bottom: -29,
    zIndex: 6,
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },

  // Outer shell keeps the shadow while inner wrapper does the hard clipping.
  logoShell: {
    width: 82,
    height: 82,
    borderRadius: 41,
    backgroundColor: '#FFFFFF',
    padding: 3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.14,
    shadowRadius: 10,
    elevation: 5,
  },
  logoClip: {
    flex: 1,
    borderRadius: 38,
    overflow: 'hidden',
    backgroundColor: '#F4F4F4',
  },
  logo: {
    width: '100%',
    height: '100%',
    borderRadius: 38,
    backgroundColor: '#F4F4F4',
  },

  bannerArrowRight: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: [{ translateY: -20 }],
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255,255,255,0.94)',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.06)',
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 7,
    elevation: 2,
  },
  dotsWrap: {
    position: 'absolute',
    bottom: 12,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: 'rgba(255,255,255,0.58)',
    marginHorizontal: 3,
  },
  dotActive: {
    width: 18,
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },

  // Booked recently — Collabbay yellow
  bookedRecentlyPill: {
    backgroundColor: '#FDF05D',
    borderRadius: 999,
    paddingVertical: 7,
    paddingHorizontal: 11,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#F1E44F',
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 8,
    elevation: 2,
  },
  bookedRecentlyText: {
    marginLeft: 6,
    fontSize: 12,
    color: '#242424',
    fontWeight: '400',
  },
  bookedRecentlyCount: {
    color: '#111111',
    fontWeight: '600',
  },

  // Main content hierarchy
  section: {
    marginBottom: 18,
  },
  headerSectionTitle: {
    fontSize: 27,
    lineHeight: 34,
    letterSpacing: -0.5,
    color: '#111111',
    fontWeight: '600',
    marginBottom: 10,
  },
  eyebrowLabel: {
    fontSize: 11,
    lineHeight: 15,
    letterSpacing: 1.15,
    color: '#787878',
    fontWeight: '600',
    marginBottom: 7,
  },
  descriptionBox: {
    paddingTop: 12,
    paddingBottom: 8,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
    marginTop: 12,
  },
  description: {
    fontSize: 15.5,
    lineHeight: 23,
    color: '#4E4E4E',
    fontWeight: '400',
  },
  locationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 38,
    marginBottom: 4,
    paddingVertical: 5,
  },
  sectionTitleAddress: {
    fontSize: 14.5,
    lineHeight: 20,
    marginLeft: 10,
    color: '#454545',
    fontWeight: '400',
    flexShrink: 1,
  },
  urlContainer: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '100%',
    paddingVertical: 6,
    marginTop: 2,
    marginBottom: 4,
  },
  urlText: {
    marginLeft: 9,
    fontSize: 14.5,
    lineHeight: 20,
    color: '#313131',
    textDecorationLine: 'underline',
    flexShrink: 1,
  },
  followersRequirementBox: {
    alignSelf: 'flex-start',
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 999,
    backgroundColor: '#F7F7F7',
    borderWidth: 1,
    borderColor: '#ECECEC',
  },
  followersRequirementText: {
    fontSize: 12,
    color: '#555555',
    fontWeight: '500',
  },

  // Availability
  availabilityContainer: {
    marginTop: 10,
    paddingTop: 18,
    paddingBottom: 4,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
  },
  availabilityHeader: {
    fontSize: 17,
    lineHeight: 22,
    fontWeight: '500',
    marginBottom: 12,
    color: '#161616',
  },
  availabilityList: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  availabilityItem: {
    backgroundColor: '#F7F7F7',
    paddingVertical: 8,
    paddingHorizontal: 11,
    borderRadius: 999,
    marginRight: 7,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: '#EEEEEE',
  },
  availabilityText: {
    fontSize: 13,
    color: '#4B4B4B',
    fontWeight: '400',
  },
  noAvailabilityText: {
    fontSize: 13,
    color: '#8C8C8C',
    fontStyle: 'italic',
  },

  // Content brief
  contentBriefContainer: {
    marginTop: 18,
    marginBottom: 24,
    paddingTop: 22,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
  },
  sectionTitle: {
    fontSize: 19,
    lineHeight: 25,
    fontWeight: '500',
    color: '#161616',
    marginBottom: 14,
  },
  briefList: {
    width: '100%',
  },
  briefRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 11,
  },
  briefCheck: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: '#FFF9C7',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
    marginTop: 1,
  },
  bulletPoint: {
    flex: 1,
    fontSize: 15,
    lineHeight: 22,
    color: '#3D3D3D',
    fontWeight: '400',
  },

  // Offer
  offerUnifiedCard: {
    backgroundColor: '#FAFAFA',
    borderRadius: 22,
    paddingHorizontal: 18,
    paddingTop: 18,
    paddingBottom: 16,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: '#EEEEEE',
  },
  offerMainTitle: {
    fontSize: 19,
    lineHeight: 25,
    color: '#151515',
    fontWeight: '500',
    marginBottom: 14,
  },
  offerHighlightBox: {
    paddingVertical: 2,
    marginBottom: 15,
  },
  offerHighlightText: {
    fontSize: 20,
    lineHeight: 28,
    color: '#161616',
    fontWeight: '600',
    letterSpacing: -0.2,
  },
  offerValueRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 14,
    borderTopWidth: 1,
    borderTopColor: '#E8E8E8',
  },
  offerValueLabel: {
    fontSize: 12,
    lineHeight: 16,
    color: '#7A7A7A',
    marginBottom: 1,
    fontWeight: '400',
  },
  offerValueAmount: {
    fontSize: 15,
    lineHeight: 20,
    fontWeight: '600',
    color: '#111111',
  },
  customOfferWrap: {
    marginTop: 10,
    marginBottom: 26,
  },
  customOfferPromptButton: {
    minHeight: 50,
    borderWidth: 1,
    borderColor: '#E1E1E1',
    borderRadius: 15,
    paddingHorizontal: 16,
    backgroundColor: '#FFFFFF',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  customOfferPromptText: {
    fontSize: 14.5,
    color: '#444444',
    fontWeight: '500',
  },
  customOfferPanel: {
    backgroundColor: '#FAFAFA',
    borderWidth: 1,
    borderColor: '#E8E8E8',
    borderRadius: 20,
    padding: 16,
  },
  customOfferTitle: {
    fontSize: 17,
    fontWeight: '500',
    color: '#171717',
    marginBottom: 4,
  },
  customOfferHelper: {
    fontSize: 13,
    lineHeight: 19,
    color: '#777777',
    marginBottom: 14,
  },
  customOfferTextarea: {
    minHeight: 102,
    borderWidth: 1,
    borderColor: '#DDDDDD',
    borderRadius: 15,
    paddingHorizontal: 14,
    paddingVertical: 13,
    backgroundColor: '#FFFFFF',
    color: '#222222',
    fontSize: 15,
    textAlignVertical: 'top',
  },
  customOfferCounter: {
    fontSize: 11,
    color: '#999999',
    textAlign: 'right',
    marginTop: 5,
    marginBottom: 10,
  },
  customOfferInput: {
    minHeight: 50,
    borderWidth: 1,
    borderColor: '#DDDDDD',
    borderRadius: 15,
    paddingHorizontal: 14,
    backgroundColor: '#FFFFFF',
    color: '#222222',
    fontSize: 15,
  },

  // Booking
  bookingIntro: {
    marginTop: 18,
    marginBottom: 15,
    paddingTop: 24,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
  },
  bookingTitle: {
    fontSize: 23,
    lineHeight: 29,
    fontWeight: '600',
    letterSpacing: -0.35,
    color: '#111111',
    marginBottom: 4,
  },
  bookingHelper: {
    fontSize: 14,
    lineHeight: 20,
    color: '#777777',
  },
  stepLabel: {
    fontSize: 14,
    color: '#3F3F3F',
    fontWeight: '500',
    marginBottom: 10,
  },
  calendarContainer: {
    marginBottom: 22,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#EAEAEA',
    borderRadius: 20,
    paddingHorizontal: 8,
    paddingTop: 14,
    paddingBottom: 8,
    overflow: 'hidden',
  },
  timePickerContainer: {
    marginBottom: 26,
  },
  timePickerLabel: {
    fontSize: 16,
    fontWeight: '500',
    marginBottom: 10,
    color: '#222222',
  },
  timeScrollView: {
    maxHeight: 244,
  },
  timeGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingBottom: 2,
  },
  timeSlot: {
    width: '31.7%',
    minHeight: 46,
    marginBottom: 9,
    borderWidth: 1,
    borderColor: '#E2E2E2',
    borderRadius: 14,
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
  },
  selectedTimeSlot: {
    backgroundColor: '#151515',
    borderColor: '#151515',
  },

  // Times that fall before opening / after closing are clearly unavailable.
  disabledTimeSlot: {
    backgroundColor: '#F4F4F4',
    borderColor: '#ECECEC',
    opacity: 0.72,
  },
  timeSlotText: {
    fontSize: 13,
    color: '#333333',
    fontWeight: '500',
  },
  disabledTimeSlotText: {
    color: '#B2B2B2',
    fontWeight: '400',
  },
  selectedTimeSlotText: {
    color: '#FFFFFF',
  },

  // Inputs
  additionalDetailsCard: {
    paddingTop: 22,
    marginBottom: 24,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: '500',
    color: '#171717',
    marginBottom: 4,
  },
  cardHelper: {
    fontSize: 13,
    lineHeight: 19,
    color: '#7B7B7B',
    marginBottom: 13,
  },
  inputField: {
    minHeight: 52,
    borderWidth: 1,
    borderColor: '#DDDDDD',
    borderRadius: 15,
    paddingHorizontal: 14,
    marginBottom: 10,
    backgroundColor: '#FFFFFF',
    fontSize: 15,
    color: '#222222',
  },
  messageInput: {
    marginBottom: 24,
    paddingTop: 22,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
  },
  messageTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  messageInputTitle: {
    fontSize: 17,
    lineHeight: 22,
    fontWeight: '500',
    color: '#171717',
  },
  optionalLabel: {
    fontSize: 12,
    color: '#8C8C8C',
    fontWeight: '400',
  },
  messageBoxInput: {
    minHeight: 112,
    borderWidth: 1,
    borderColor: '#DDDDDD',
    borderRadius: 16,
    paddingHorizontal: 14,
    paddingVertical: 13,
    fontSize: 15,
    lineHeight: 21,
    color: '#222222',
    backgroundColor: '#FFFFFF',
    textAlignVertical: 'top',
  },
  charCounter: {
    fontSize: 11,
    color: '#9A9A9A',
    textAlign: 'right',
    marginTop: 6,
  },
  visitorInputContainer: {
    marginBottom: 26,
    paddingTop: 22,
    borderTopWidth: 1,
    borderTopColor: '#EFEFEF',
  },
  visitorInputLabel: {
    fontSize: 17,
    lineHeight: 22,
    fontWeight: '500',
    color: '#171717',
    marginBottom: 5,
  },
  plusOneLabel: {
    fontSize: 12.5,
    lineHeight: 18,
    color: '#7A7A7A',
    marginBottom: 14,
  },
  visitorOptions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  visitorOption: {
    minWidth: 47,
    textAlign: 'center',
    fontSize: 14,
    color: '#333333',
    fontWeight: '500',
    paddingVertical: 11,
    paddingHorizontal: 13,
    borderRadius: 13,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    backgroundColor: '#FFFFFF',
    marginRight: 8,
    marginBottom: 8,
    overflow: 'hidden',
  },
  selectedVisitorOption: {
    backgroundColor: '#151515',
    borderColor: '#151515',
    color: '#FFFFFF',
  },

  // CTA / states
  collabButton: {
    minHeight: 58,
    backgroundColor: '#151515',
    borderRadius: 17,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 18,
    marginTop: 4,
    marginBottom: 30,
    shadowColor: '#000',
    shadowOpacity: 0.10,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 10,
    elevation: 3,
  },
  collabButtonText: {
    fontSize: 16,
    lineHeight: 21,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  ctaRewardText: {
    fontSize: 12,
    lineHeight: 17,
    color: '#CFCFCF',
    marginTop: 3,
    fontWeight: '400',
  },
  warningCard: {
    backgroundColor: '#FFFBEB',
    paddingHorizontal: 15,
    paddingVertical: 13,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#F5E6B7',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginVertical: 14,
  },
  warningText: {
    fontSize: 13,
    lineHeight: 19,
    color: '#5F5430',
    marginLeft: 10,
    flex: 1,
    fontWeight: '400',
  },
  verificationCard: {
    backgroundColor: '#FAFAFA',
    padding: 20,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#E8E8E8',
    alignItems: 'center',
    marginVertical: 16,
  },
  verificationText: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    marginTop: 9,
  },

  // Modals
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(17,17,17,0.38)',
    paddingHorizontal: 18,
  },
  modalContent: {
    width: '100%',
    maxWidth: 440,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 22,
    paddingTop: 24,
    paddingBottom: 20,
    borderRadius: 26,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.05)',
    shadowColor: '#000',
    shadowOpacity: 0.12,
    shadowOffset: { width: 0, height: 10 },
    shadowRadius: 24,
    elevation: 8,
  },
  modalText: {
    fontSize: 15,
    lineHeight: 22,
    textAlign: 'center',
    color: '#454545',
    marginTop: 12,
    marginBottom: 18,
    fontWeight: '400',
  },
  modalButton: {
    minHeight: 50,
    minWidth: 150,
    backgroundColor: '#151515',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalButtonText: {
    fontSize: 15,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  successCard: {
    width: '92%',
    maxWidth: 460,
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    alignItems: 'center',
  },
  successCardRefined: {
    width: '92%',
    maxWidth: 460,
    maxHeight: '88%',
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    paddingTop: 24,
    paddingBottom: 22,
    paddingHorizontal: 22,
    borderWidth: 1,
    borderColor: '#ECECEC',
    shadowColor: '#000',
    shadowOpacity: 0.11,
    shadowOffset: { width: 0, height: 10 },
    shadowRadius: 24,
    elevation: 8,
  },
  successCardEligible: {
    width: '92%',
    maxWidth: 460,
    maxHeight: '88%',
  },
  successCloseButton: {
    position: 'absolute',
    top: 14,
    right: 14,
    width: 38,
    height: 38,
    borderRadius: 19,
    backgroundColor: '#F7F7F7',
    borderWidth: 1,
    borderColor: '#ECECEC',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 20,
  },
  successScrollView: {
    width: '100%',
  },
  successScrollContent: {
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 2,
  },
  successIconWrap: {
    width: 54,
    height: 54,
    borderRadius: 27,
    backgroundColor: '#ECFDF3',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 13,
  },
  rewardPill: {
    backgroundColor: '#FFF9C7',
    paddingHorizontal: 11,
    paddingVertical: 5,
    borderRadius: 999,
    marginBottom: 10,
  },
  rewardPillText: {
    color: '#4E4800',
    fontSize: 12,
    fontWeight: '500',
  },
  successTitle: {
    fontSize: 23,
    lineHeight: 29,
    fontWeight: '600',
    letterSpacing: -0.3,
    textAlign: 'center',
    color: '#111111',
    marginTop: 3,
  },
  successSubtitle: {
    fontSize: 14,
    lineHeight: 20,
    color: '#707070',
    textAlign: 'center',
    marginTop: 6,
    marginBottom: 6,
    fontWeight: '400',
  },
  successDivider: {
    width: '100%',
    height: 1,
    backgroundColor: '#EEEEEE',
    marginTop: 18,
    marginBottom: 18,
  },
  engagementModernCard: {
    width: '100%',
    backgroundColor: '#F7FAFF',
    borderWidth: 1,
    borderColor: '#DCE7F7',
    borderRadius: 20,
    padding: 16,
  },
  engagementHeaderRow: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 13,
  },
  engagementMiniLabel: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  engagementMiniLabelText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#1D4ED8',
    letterSpacing: 0.8,
  },
  engagementOptionalBadgeDark: {
    backgroundColor: '#EEF3FA',
    borderRadius: 999,
    paddingHorizontal: 9,
    paddingVertical: 5,
  },
  engagementOptionalBadgeDarkText: {
    fontSize: 9,
    fontWeight: '600',
    color: '#60738C',
    letterSpacing: 0.65,
  },
  engagementHeadlineRow: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 9,
  },
  engagementIconWrapBlue: {
    width: 38,
    height: 38,
    borderRadius: 12,
    backgroundColor: '#EAF2FF',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  engagementTitleGradient: {
    flex: 1,
    fontSize: 17,
    lineHeight: 22,
    fontWeight: '600',
    letterSpacing: -0.2,
    color: '#173E76',
  },
  engagementBodyRefined: {
    width: '100%',
    fontSize: 13.5,
    lineHeight: 20,
    color: '#60738C',
    marginBottom: 14,
    fontWeight: '400',
  },
  emailVenueButtonRefined: {
    width: '100%',
    minHeight: 50,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D7E1EF',
    borderRadius: 14,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emailVenueButtonTextRefined: {
    fontSize: 14.5,
    fontWeight: '600',
    color: '#1B2A40',
  },
  continueBrowsingPrimaryButton: {
    width: '100%',
    minHeight: 56,
    backgroundColor: '#151515',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 18,
  },
  continueBrowsingPrimaryButtonText: {
    fontSize: 15.5,
    fontWeight: '600',
    color: '#FFFFFF',
  },

  // Exit survey
  exitSurveyCard: {
    width: '100%',
    maxWidth: 440,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingTop: 12,
    paddingBottom: 20,
    borderRadius: 28,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.05)',
    shadowColor: '#000',
    shadowOpacity: 0.12,
    shadowOffset: { width: 0, height: 10 },
    shadowRadius: 24,
    elevation: 8,
  },
  exitSurveyHandle: {
    width: 38,
    height: 4,
    borderRadius: 2,
    backgroundColor: '#D8D8D8',
    marginBottom: 18,
  },
  exitSurveyTitle: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: '600',
    color: '#151515',
    textAlign: 'center',
    marginBottom: 4,
  },
  exitSurveySubtitle: {
    fontSize: 13,
    lineHeight: 19,
    color: '#7A7A7A',
    textAlign: 'center',
    marginBottom: 16,
  },
  exitReasonButton: {
    width: '100%',
    minHeight: 48,
    paddingVertical: 12,
    paddingHorizontal: 13,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#E4E4E4',
    backgroundColor: '#FFFFFF',
    marginBottom: 9,
    justifyContent: 'center',
  },
  exitReasonButtonSelected: {
    backgroundColor: '#FFF9BE',
    borderColor: '#F4E758',
  },
  exitReasonText: {
    textAlign: 'center',
    fontSize: 14,
    color: '#3A3A3A',
    fontWeight: '400',
  },
  exitProgressTrack: {
    width: '100%',
    height: 5,
    backgroundColor: '#F0F0F0',
    borderRadius: 999,
    overflow: 'hidden',
    marginTop: 7,
  },
  exitProgressFill: {
    height: '100%',
    backgroundColor: '#FDF05D',
    alignSelf: 'flex-start',
  },
  exitSkipButton: {
    marginTop: 14,
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  exitSkipText: {
    fontSize: 13,
    color: '#777777',
  },
});

export default CreateSubmissionPage;